import React ,{ useRef } from  'react'
import screenGrab from '../../../images/screenGrab.JPG'

import emailjs from '@emailjs/browser';

const First_Pane = () => {



    const form = useRef()


    const sendEmail = (e) => {
       e.preventDefault();
   
       emailjs.sendForm('service_4lwrm3e', 'template_ma7ii8w', form.current, 'SX0CPtK14-r61NbnF')
         .then((result) => {
             console.log(result.text);
         }, (error) => {
             console.log(error.text);
         });
     };










  return (
    <div>   
         <div className=''
    
    style={{ 
    
        backgroundImage: `-webkit-linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${screenGrab})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        paddingBottom: '200px',
        backgroundAttachment:'fixed',
        height: 'auto',

    
    }}
    >

          <div className='uk-container '>
            <div className=''>       
     <h1 className='light  dreamText uk-text-left uk-margin-xlarge-top' 
  >Your Dream Home, one email away.</h1>
          </div>
          </div>


          </div>






          <div className='uk-container uk-margin-large-top'>

                        <div className='uk-grid uk-grid-collapse' data-uk-grid>
                            <div className='uk-width-1-3@s uk-padding' style={{backgroundColor:'#1d4344'}}>
                               <h3 className='light'>Lets get to chat</h3>


                               <div className='uk-flex uk-padding-small  '>
                                <div><a href="" className='light' ratio='1.4' uk-icon="icon: home"></a> </div>
                                <div className='uk-margin-left'> <p className='light  contText uk-text-left'><span className='uk-text-bold'>Address: </span> House 44,Dublin Plaza Wuse 2</p> </div>
                               </div>


                               <div className='uk-flex uk-margin-top uk-padding-small '>
                                <div><a href="" className='light' ratio='1.4' uk-icon="icon: phone"></a> </div>
                                <div className='uk-margin-left'> <p className='light contText  uk-text-left'><span className='uk-text-bold'>Phone: </span> +234 640 161 43</p> </div>
                               </div>



                               <div className='uk-flex  uk-margin-top uk-padding-small '>
                                <div><a href="" className='light' ratio='1.4' uk-icon="icon: mail"></a> </div>
                                <div className='uk-margin-left'> <p className='light  contText uk-text-left'><span className='uk-text-bold'>Email: </span> info@bolek.com.ng</p> </div>
                               </div>



                            </div>

                            <div className='uk-width-2-3@s shadow'>

                                <div className='uk-padding'>
                                                                        
                        

                                <form ref={form}  onSubmit={sendEmail}>
                                    <div className='input-row'>
                                    <div className='input-group'>
                                        <label>Name</label>
                                        <input type="text" name = "user_name"  placeholder='John Domelo' />
                                    </div>

                                    <div className='input-group'>
                                        <label>Phone</label>
                                        <input type="text" name = "phone_number" placeholder='+234 879 894' />
                                    </div>
                                    </div>


                                    <div className='input-row'>
                                    <div className='input-group'>
                                        <label>Email</label>
                                        <input type="email" name = "user_email" placeholder='ab_i@mail.com' />
                                    </div>

                                    <div className='input-group'>
                                        <label>Subject</label>
                                        <input type="text" name = "subject" placeholder='+234 879 894' />
                                    </div>
                                    </div>


                                    <label>Message</label>
                                    <textarea rows="5" name = "text-area" placeholder='Your message'></textarea>
                                    <button type='submit'>SEND</button>
                                    </form>



                                </div>

                            </div>
                        </div>

</div>


    </div>
  )
}

export default First_Pane